import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function reassign(params) {
  const axios = axiosInstance().primoLab;
  let testWorkQueue = [];

  await axios
    .put(`/test-work-queues/`, params)
    .then(async (response) => {
      testWorkQueue = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { testWorkQueue };
}
